// BackNavigationGuard is now handled by the Login page's authenticated-user detection.
// This file is kept as a no-op to avoid import errors from ProtectedRoute.
export function BackNavigationGuard() {
  return null;
}
